import type { IScreenDesignContextState } from "../../contexts/screen-design-context/screen-design-context";
import type { ScreenDesignContextProvider } from "../../contexts/screen-design-context/screen-design-context-provider";

/**
 * The raw ScreenDesignContextProvider instance.
 * All MCP tool utilities accept this type and access sub-providers directly.
 */
export type ScreenDesignInstance = ScreenDesignContextProvider;

declare let window: { getSdInstance?: () => ScreenDesignInstance };

/**
 * Get the singleton ScreenDesignContextProvider instance from the window.
 */
export function getSdInstance(): ScreenDesignInstance {
  const instance = window.getSdInstance?.();
  if (!instance) {
    throw new Error("Designer not initialized. No screen design context available.");
  }
  return instance;
}

/**
 * Get the flat context state from the raw provider instance.
 * Shorthand for sd.getScreenDesignContextProviderValues().
 */
export function getValues(sd: ScreenDesignInstance): IScreenDesignContextState {
  return sd.getScreenDesignContextProviderValues();
}
